import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../../../constants/index";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import validate from "./validate";
import { toast } from "react-toastify";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import EditorComponent from "../../../../components/editor";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "45px",
    minHeight: "45px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "45px",
    padding: "0 6px",
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "45px",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const Postjobform = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  const { id } = useParams();
  const [pageTitle, setPageTitle] = useState("");
  const [icon, setIcon] = useState("fa fa-user");
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setPageTitle("Open Job");
      setIcon("fa fa-user");
    } else {
      setPageTitle("");
      // setIcon('');
    }
  };

  window.addEventListener("scroll", handleScroll);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Open Job"));
  }, []);

  let [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Title: [],
    Description: "",
    NoOfPosition: 1,
    JobType: "",
    Technology: [],
    Qualification: "",
    MinExperience: "",
    MaxExperience: "",
    budget_min_scale: "",
    budget_max_scale: "",
    Location: [],
    ActiveDate: moment().format("DD-MMM-YYYY"),
    TargetDate: "",
    IsInActive: "",
    RequisitionID: "",
  });

  const handleDateChange =  (date, name)  => {
    // const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: moment(date).format("DD-MMM-YYYY"),
    }));

  };

  const formRef = useRef(null);
  const [typeOptions, setTypeOptions] = useState([]);
  const [technologyOptions, setTechnologyOptions] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [jobTitleOptions, setjobTitleOptions] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [activeStatus, setActiveStatus] = useState(false);

  const initialized = useRef(false);

  useEffect(() => {
    setActive();
    if (id) {
      fetchData(id);
    } else {
      fetchOptions();
    }
  }, []);

  const fetchOptions = async () => {
    // const response = await GetServiceCaller(`${API_URL}JobDescriptions`);

    try {
      const response = await GetServiceCaller(
        `${API_URL}JobDescriptions/create`
      );
      if (response.status === 200) {
        const technologyData = response?.data?.data?.technology;
        const locationoption = response?.data?.data?.projectlocation;
        const titleoption = response?.data?.data?.job_titles;

        const options = technologyData?.map((tech) => ({
          value: tech.ID,
          label: tech.Name,
        }));
        const LocationOption = locationoption?.map((tech) => ({
          value: tech.ID,
          label: tech.Name,
        }));
        const TitleOption = titleoption?.map((tech) => ({
          value: tech.ID,
          label: tech.Name,
        }));

        TitleOption.unshift({ value: null, label: "Select.." });
        LocationOption.unshift({ value: null, label: "Select.." });

        setTechnologyOptions(options);
        setLocationOptions(LocationOption);
        setjobTitleOptions(TitleOption);

        const jobType = response?.data?.data?.jobType;
        const jobTypeOptions = jobType?.map((master) => ({
          value: master.value,
          label: master.Description,
        }));
        setTypeOptions(jobTypeOptions);
        const job = response?.data?.jobDescription;
        if (job) {
          const {
            Title,
            Description,
            NoOfPosition,
            JobType,
            Technology,
            MinExperience,
            MaxExperience,
            budget_min_scale,
            budget_max_scale,
            Qualification,
            Location,
            ActiveDate,
            TargetDate,
            IsInActive,
          } = job;

          // Job display in select form string to array
          let job_selected = [];

          const matchedTitle = titleoption?.find(
            (item) => item.text === job.Title.toString()
          );

          if (matchedTitle) {
            job_selected?.push({
              value: matchedTitle.value,
              label: job.Title.toString(),
            });
          }

          // Techology is selected from a ids string to array
          let technology_selected = [];
          const techSource = job.Skills || job.Technology;
          techSource?.toString().split(",")
            .map((item) => item.trim())
            .forEach((element) => {
              const found = options.find((o) => o.value == element || o.label?.toLowerCase() === element.toLowerCase());
              if (found) {
                technology_selected.push(found);
              }
            });

          //Location to be shown in select from string to array
          let location_selected = [];
          Location?.toString().split(",")
            .map((item) => item.trim())
            .forEach((element) => {
              const found = LocationOption.find((L) => L.label?.toLowerCase() === element.toLowerCase() || L.value?.toString() === element);
              if (found) {
                location_selected.push(found);
              }
            });

          // Update form data with fetched values
          setFormData({
            Title: job_selected || "",
            Description: Description || "",
            NoOfPosition: NoOfPosition || "",
            JobType: JobType || "",
            Technology: technology_selected || "",
            Qualification: Qualification || "",
            MinExperience: MinExperience || "",
            MaxExperience: MaxExperience || "",
            budget_min_scale: budget_min_scale || "",
            budget_max_scale: budget_max_scale || "",
            Location: location_selected || "",
            ActiveDate: moment(ActiveDate).format("DD-MMM-YYYY") || "",
            // TargetDate: moment(TargetDate).format("DD-MMM-YYYY") || "",
            TargetDate: TargetDate ? moment(TargetDate).format("DD-MM-YYYY") : "",
            IsInActive: IsInActive ? 0 : 1,
          });
        } else {
          console.error("Job not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch job details. Server responded with status:",
          response.status
        );
      }
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
  };

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}JobDescriptions/create`
      );
      const technologyData = response?.data?.data?.technology;
      const locationoption = response?.data?.data?.projectlocation;
      const titleoption = response?.data?.data?.job_titles;

      const options = technologyData?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      const LocationOption = locationoption?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      const TitleOption = titleoption?.map((tech) => ({
        value: tech.ID,
        label: tech.Name,
      }));
      TitleOption.unshift({ value: null, label: "Select.." });
      LocationOption.unshift({ value: null, label: "Select.." });

      setTechnologyOptions(options);
      setLocationOptions(LocationOption);
      setjobTitleOptions(TitleOption);

      const jobType = response?.data?.data?.jobType;
      const jobTypeOptions = jobType?.map((master) => ({
        value: master.value,
        label: master.Description,
      }));
      setTypeOptions(jobTypeOptions);
      if (id) {
        try {
          const response = await GetServiceCaller(
            `${API_URL}JobDescriptions/${id}`
          );
          if (response.status === 200) {
            const job = response?.data?.data;
            if (job) {
              const {
                Title,
                JobMasterID,
                Description,
                NoOfPosition,
                JobType,
                Technology,
                Skills,
                MinExperience,
                MaxExperience,
                budget_min_scale,
                budget_max_scale,
                Qualification,
                Location,
                ActiveDate,
                TargetDate,
                IsInActive,
                RequisitionID,
              } = job;

              // Job display in select form string to array
              let job_selected = { value: JobMasterID, label: Title };

              // Techology is selected from a ids string to array
              let technology_selected = [];
              const techSource = Skills || Technology;
              techSource?.toString().split(",")
                .map((item) => item.trim())
                .forEach((element) => {
                  const found = options.find((o) => o.value == element || o.label?.toLowerCase() === element.toLowerCase());
                  if (found) {
                    technology_selected.push(found);
                  }
                });

              //Location to be shown in select from string to array
              let location_selected = [];
              Location?.toString().split(",")
                .map((item) => item.trim())
                .forEach((element) => {
                  const found = LocationOption.find((L) => L.label?.toLowerCase() === element.toLowerCase() || L.value?.toString() === element);
                  if (found) {
                    location_selected.push(found);
                  }
                });
              // Update form data with fetched values
              let job_type_selected = {};
              for (let type of jobTypeOptions) {
                if (type.value == JobType) {
                  job_type_selected = type;
                }
              }
              setFormData({
                Title: job_selected || "",
                Description: Description || "",
                NoOfPosition: NoOfPosition || "",
                JobType: job_type_selected || "",
                Technology: technology_selected || "",
                Qualification: Qualification || "",
                MinExperience: MinExperience || "",
                MaxExperience: MaxExperience || "",
                budget_min_scale: budget_min_scale || "",
                budget_max_scale: budget_max_scale || "",
                Location: location_selected || "",
                ActiveDate: moment(ActiveDate).format("DD-MMM-YYYY") || "",
                TargetDate: TargetDate ? moment(TargetDate).format("DD-MM-YYYY") : "",
                IsInActive: IsInActive ? 1 : 0,
                RequisitionID: RequisitionID || "",
              });
            } else {
              console.error("Job not found with ID:", id);
            }
          } else {
            console.error(
              "Failed to fetch job details. Server responded with status:",
              response.status
            );
          }
          setPageLoading(false);
        } catch (error) {
          console.error("Error fetching job details:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching technology options:", error);
    }
  };

  const setActive = () => {
    if (!activeStatus) {
      if (formData.IsInActive == 1) {
        setSelectedRating("Yes");
      } else {
        setSelectedRating("No");
      }
      setActiveStatus(true);
    }
  };

  //handlechage on jobtitle
  const handleDropDownChange = (selected) => {
    setFormData({ ...formData, Title: selected });

    setErrors((prevErrors) => ({
      ...prevErrors,
      Title: "",
    }));
  };

  const handleBudgetChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRatingChange = (ratingValue) => {
    setSelectedRating(ratingValue);
    setFormData({
      ...formData,
      IsInActive: ratingValue == "Yes" ? 1 : 0,
    });
  };
  const handleTypeChange = (selected, name) => {
    setFormData({
      ...formData,
      [name]: selected,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = value;
    if (type === "checkbox") {
      val = checked;
    } else if (name === "Technology") {
      // For Technology, extract only IDs
      val = value.map((option) => option.value);
    }

    setFormData({ ...formData, [name]: val });
    if (name === "ActiveDate" && val === "" && type === "text") {
      const currentDate = new Date().toISOString().split("T")[0];
      setFormData({ ...formData, [name]: currentDate });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate mandatory fields
    let mandatory_field = ["Title", "Technology", "ActiveDate", "TargetDate"];
    let isFormInvalid = false;
    for (let field of mandatory_field) {
      let error = await validate([field], formData[field], formData);
      if (error.status === true) {
        isFormInvalid = true;
      }
      setErrors((errors) => ({
        ...errors,
        [field]: error,
      }));
    }

    // Validate budget range
    const minBudget = parseFloat(formData?.budget_min_scale);
    const maxBudget = parseFloat(formData?.budget_max_scale);
    if (minBudget > maxBudget) {
      toast.error("Max budget must be greater than or equal to Min budget.");
      isFormInvalid = true;
    }

    // Validate experience range
    const minExperience = parseFloat(formData?.MinExperience);
    const maxExperience = parseFloat(formData?.MaxExperience);
    if (minExperience > maxExperience) {
      toast.error(
        "Max experience must be greater than or equal to Min experience."
      );
      isFormInvalid = true;
    }

    // Validate TargetDate is greater than ActiveDate
    if (
      moment(formData.TargetDate, "DD-MM-YYYY").isSameOrBefore(
        moment(formData.ActiveDate, "DD-MM-YYYY")
      )
    ) {
      toast.error("Target Date must be greater than Active Date.");
      isFormInvalid = true;
    }

    if (!isFormInvalid) {
      setSubmit(true);
      try {
        const technologyIDs = formData?.Technology?.map((option) =>
          option?.value?.toString()
        ).join(",");

        const jobDescriptionLabel = formData?.Title;

        let LocationString = formData?.Location?.map((obj) => obj.label)?.join(
          ", "
        );

        const data = {
          ...formData,
          Technology: technologyIDs,
          Title: jobDescriptionLabel,
          Location: LocationString,
        };

        let response;
        if (id) {
          response = await PostServiceCaller(
            `${API_URL}JobDescriptions/${id}`,
            data,
            "put"
          );
          toast.success(response?.data?.message);
          setSubmit(false);
          navigate("/postjob");
        } else {
          response = await PostServiceCaller(
            `${API_URL}JobDescriptions`,
            data,
            "post"
          );
          toast.success(response?.data?.message);
          setSubmit(false);
          navigate("/postjob");
        }
      } catch (error) {
        console.error("Error submitting form data:", error);
      }
    }
  };

  const handleOnTouch = async (e) => {
    const { name, value } = e.target;
    let error = await validate(name, value, formData);
    setErrors((errors) => ({
      ...errors,
      [name]: error,
    }));
  };

  const onEditorChange = (data) => {
    formData.Description = data;
  };

  const handleMultiSelect = (selectedOption, fieldName) => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: selectedOption || [], // Ensure selectedOption is an array
    }));

    // Perform validation
    if (selectedOption.length === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "This field is required.",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "", // Clear error if options are selected
      }));
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form
            ref={formRef} 
            onSubmit={handleSubmit}
            id="formOne"
            className="rounded mt-2 bg-white"
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 border-end-4">
                  <div className="row">
                    <div className="col-md-6 col-lg-3">
                      <label className="form-label py-0">
                        Job Title<span className="required">*</span>
                      </label>
                      <Select
                        options={jobTitleOptions}
                        name="Title"
                        value={formData.Title}
                        onChange={(e) => handleDropDownChange(e, "Title")}
                        isDisabled={!!formData.RequisitionID}
                      />
                      <span class="error">{errors?.Title?.message}</span>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <label htmlFor="position" className="form-label">
                        Type
                      </label>

                      <Select
                        name="JobType"
                        value={formData.JobType}
                        options={[
                          { value: "", label: "Select..." },
                          ...typeOptions,
                        ]}
                        onChange={(selected) => {
                          handleTypeChange(selected, "JobType");
                        }}
                      />
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <label htmlFor="NoOfPosition" className="form-label">
                        #POS
                      </label>
                      <div className="col-md-12">
                        <input
                          JobType="number"
                          className="form-control text-end"
                          id="NoOfPosition"
                          name="NoOfPosition"
                          value={formData.NoOfPosition}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="d-flex flex-column">
                        <label
                          htmlFor="budget_min_scale"
                          className="form-label"
                        >
                          Budget (in LPA)
                        </label>
                        <div className="row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              className="form-control text-end"
                              id="budget_min_scale"
                              name="budget_min_scale"
                              placeholder="Min"
                              value={formData.budget_min_scale}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              className="form-control text-end"
                              id="budget_max_scale"
                              name="budget_max_scale"
                              placeholder="Max"
                              value={formData.budget_max_scale}
                              onChange={handleBudgetChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-lg-3">
                      <label htmlFor="Qualification" className="form-label">
                        Qualification
                      </label>
                      <input
                        placeholder="Qualifications"
                        className="form-control"
                        id="Qualification"
                        name="Qualification"
                        value={formData.Qualification}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <label htmlFor="ActiveDate" className="form-label">
                        Active Date<span className="required">* </span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        onBlur={handleOnTouch}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        // placeholderText="Active Date"
                        format="d-MM-YYYY"
                        name="ActiveDate"
                        id="ActiveDate"
                        value={formData.ActiveDate}
                        onChange={(date) =>
                          handleDateChange(date, "ActiveDate")
                        }
                      />
                      <span class="error">{errors?.ActiveDate?.message}</span>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <label htmlFor="TargetDate" className="form-label">
                        Target Date
                      </label>

                      <ReactDatePicker
                          autoComplete="off"
                          minDate={new Date()}
                          changeYear
                          changeMonth
                          showPopperArrow
                          showIcon
                          icon="fa fa-calendar"
                          className="form-control"
                          placeholderText="Target Date"
                          format="d-MM-YYYY"
                          name="TargetDate"
                          id="TargetDate"
                          value={formData.TargetDate}
                          onChange={(date) =>
                            handleDateChange(date, "TargetDate")
                          }
                        /> 
                      <span class="error">{errors?.TargetDate?.message}</span>
                    </div>

                    <div className="col-md-6 col-lg-3">
                      <div className="row">
                        <div className="col-6">
                          <div className="d-flex flex-column">
                            <label htmlFor="MinExperience" className="form-label">
                              Relevant Exp.
                            </label>
                            <input
                              type="number"
                              className="form-control text-end"
                              id="MinExperience"
                              name="MinExperience"
                              placeholder="Min"
                              value={formData.MinExperience}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="d-flex flex-column">
                            <label htmlFor="MaxExperience" className="form-label">
                              Total Exp.
                            </label>
                            <input
                              type="number"
                              className="form-control text-end"
                              id="MaxExperience"
                              name="MaxExperience"
                              placeholder="Max"
                              value={formData.MaxExperience}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-9">
                      <div className="row">
                        <div className="col-md-12">
                          <label htmlFor="Description" className="form-label">
                            Job Description
                          </label>
                          <EditorComponent
                            data={formData.Description}
                            onEditorChange={onEditorChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="Location" className="form-label">
                          Location
                        </label>
                        <Select
                          value={formData.Location}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti={true}
                          styles={customStyle}
                          options={LocationOptions}
                          onChange={(selectedOptions) =>
                            setFormData({
                              ...formData,
                              Location: selectedOptions,
                            })
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="Technology" className="form-label">
                          Technology<span className="required">*</span>
                        </label>

                        <Select
                          onFocus={handleOnTouch}
                          isMulti
                          name="Technology"
                          options={technologyOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={customStyle}
                          value={formData.Technology}
                          // onChange={(selectedOptions) =>
                          //   setFormData({
                          //     ...formData,
                          //     Technology: selectedOptions,
                          //   })
                          // }
                          onChange={(selectedOption) =>
                            handleMultiSelect(selectedOption, "Technology")
                          }
                        />
                        <span class="error">{errors?.Technology?.message}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="d-flex justify-content-between">
                  <div className="mt-1">
                    <div className="d-flex gap-2 justify-content-start">
                      <label htmlFor="IsInActive" className="form-label">
                        Active
                      </label>
                      <div className="me-2 mt-0">
                        <div className="d-flex">
                          <div className="form-check me-2" key={"Yes"}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`rating_1`}
                              id={`rating_1_yes`}
                              value={"Yes"}
                              checked={formData.IsInActive == 1 ? true : false}
                              onChange={() => handleRatingChange("Yes")}
                            />
                            <label className="form-check-label">Yes</label>
                          </div>
                          <div className="form-check me-2" key={"No"}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`rating_1`}
                              id={`rating_1_No`}
                              value={"No"}
                              checked={formData.IsInActive == 0 ? true : false}
                              onChange={() => handleRatingChange("No")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`rating_1_No`}
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <button className="cancel-btn me-2" onClick={() => navigate('/postjob')}>
                      Cancel
                    </button>
                    {(!formData.RequisitionID || id) && (
                      <button
                        disabled={submitted ? true : false}
                        onClick={handleSubmit}
                        type=""
                        className="custom-btn"
                      >
                        {submitted ? <FaSpinner class="sm-spinner" /> : (id ? "Update" : "Submit")}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* <div class="card-footer text-muted">
                  <div className="d-flex justify-content-end me-2">
                
                  </div>
                </div> */}
          </form>
        </div>
      </>
    );
  }
};

export default Postjobform;
